export function DateOnly(today = new Date()) {
  return `${today.getDate()}${today.getMonth()}${today.getFullYear()}`;
}
